/**
 * File: index.js
 * Project: MotorFacturacion
 * File Created: Monday, 13th January 2025 9:53:29 am
 * Author: Ricardo Fernández Cuesta (ricardo.fernandez@aerin.es)
 * Version: 1.0.0
 * -----
 * Last Modified: Monday, 13th January 2025 12:59:01 pm
 * Modified By: Ricardo Fernández Cuesta
 * -----
 * Copyright (c) 2023 - 2025 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */

/* eslint-disable global-require */
import './assets/css/vendor/bootstrap.min.css';
import './assets/css/vendor/bootstrap.rtl.only.min.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-image-lightbox/style.css';
import 'video.js/dist/video-js.css';
import {
  isMultiColorActive,
  defaultColor,
  isDarkSwitchActive,
} from './constants/defaultValues';
import { getCurrentColor, setCurrentColor } from './helpers/Utils';

let color =
  isMultiColorActive || isDarkSwitchActive ? getCurrentColor() : defaultColor;
setCurrentColor(color);

const render = () => {
  import(`./assets/css/sass/themes/gogo.${color}.scss`)
    .then(() => {
      require('./AppRenderer');
    })
    .catch(() => {
      // Si no encuentra el CSS setea la variable
      // con el color por defecto.
      color = defaultColor;
      setCurrentColor(color);

      // Reintenta importar el CSS.
      import(`./assets/css/sass/themes/gogo.${color}.scss`).then(() => {
        require('./AppRenderer');
      });
    });
};
render();
